import { FC, useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';

const SoldPrice: FC = () => {
  const { estate } = useContext(ObjectPageContext);

  return (
    <span>
      {estate?.priceInfo?.finalPrice
        ? estate?.priceInfo?.finalPrice
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'
        : estate?.priceInfo?.startPrice
        ? estate?.priceInfo?.startPrice
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'
        : 'Pris ej angivet'}
    </span>
  );
};
export default SoldPrice;
